import type { IconData } from '@stacksjs/iconify-core'

export const chefToqueHat: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"M31.568 7.127A9 9 0 0 0 24 3a9 9 0 0 0-7.568 4.127A8 8 0 1 0 8.72 20.67a479 479 0 0 0 2.18 21.55c.17 1.36 1.251 2.4 2.62 2.488C15.606 44.842 19.1 45 24 45s8.394-.158 10.48-.293c1.369-.088 2.45-1.128 2.62-2.488a479 479 0 0 0 2.18-21.549a8 8 0 1 0-7.712-13.543\"/><path stroke-linejoin=\"round\" d=\"M37.753 37.363c-2.557-.133-6.836-.265-13.753-.265s-11.197.132-13.753.265\"/><path d=\"m19 21l1 8m9-8l-1 8\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chefToqueHat
